// extracted by mini-css-extract-plugin
module.exports = {"mobileBreadcrumbs":"breadcrumbs_mobileBreadcrumbs__23uWR"};